import {
  FormControl,
  Select
} from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'

import { useSelections } from '@/hooks'
import type { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'
import { Selection, SelectionType } from 'BrokerTsLib/src/enums'
import { useContext } from 'react'
import { FormLabel } from '../../components/FormLabel'
import { InputGroup } from '../../components/InputGroup'
import { insuranceParamsContext } from '../../layouts/Wizard'


export const AdditionalPropertyInfoKb = () => {
  const { insuranceParams } = useContext(insuranceParamsContext)

  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { formState: { errors }, register, getValues, watch } = useFormContext<WizardPropertyAdditionalData>()

  const { data: dataVztah } = useSelections(SelectionType.RelationInsuredToPolicyHolder)

  const setRelation = watch('property.additionalDataKb.relationInsuredToPolicyHolder') 

  return (
    <>
        <FormControl isRequired isInvalid={!!errors.property?.additionalDataKb?.relationInsuredToPolicyHolder}>
          <FormLabel>Vztah pojistníka k pojištěnému</FormLabel>
    
          {(dataVztah?.length ?? 0) > 0 &&
            <Select
              {...register('property.additionalDataKb.relationInsuredToPolicyHolder')}
              isDisabled={isContracted}
              defaultValue={getValues('property.additionalDataKb.relationInsuredToPolicyHolder') ?? ''}              
            >
              <option value=''>Vyberte</option>
              {dataVztah?.map((item) => (
                <option value={item.id?.toString()} key={item.id}>{item.description}</option>
              ))}
            </Select>
          }
        </FormControl>

        {setRelation == Selection.RelationInsurerToPolicyHolderOther && (                
          <FormControl isRequired isInvalid={!!errors.property?.additionalDataKb?.relationInsuredToPhOtherText}>
            <FormLabel>Specifikace vztahu</FormLabel>
            <InputGroup
              isDisabled={isContracted}
              id="relationInsuredToPhText"
              htmlSize={30}
              autoComplete="off"
              errors={errors.property?.additionalDataKb?.relationInsuredToPhOtherText}
              {...register('property.additionalDataKb.relationInsuredToPhOtherText')}
            />
          </FormControl>
        )}
    </>
  )
}
